<div class="sparque-search-container">
  <div
    #searchBox
    class="search clearfix"
    [ngClass]="{ focus: searchBoxFocus, 'scaled-up': searchBoxScaledUp && searchBoxFocus }"
  >
    <input
      #searchInput
      [placeholder]="configuration()?.placeholder || ''"
      autocomplete="off"
      type="search"
      id="header-search-input"
      class="form-control searchTerm search-input search-container-card"
      (input)="handleInput($event.target)"
      [value]="inputSearchTerms$ | async"
      (focus)="handleFocus(true)"
      (keydown.enter)="submitSearch(searchInput.value)"
      [attr.aria-label]="'search.searchbox.label' | translate"
    />

    @if (configuration()?.autoSuggest && suggestions$ | async; as results) { @if ((searchBoxResults$ | async) &&
    (hasMinimumCharCount$ | async)) {
    <div id="search-suggest-layer" class="search-suggest-container" aria-labelledby="header-search-input">
      <div
        class="col-12 d-flex flex-column"
        [ngClass]="{
          'col-md-5': results.products?.length
        }"
      >
        @if (results.keywords?.length) {
        <ish-suggest-keywords
          [keywords]="results.keywords"
          [inputTerms$]="inputSearchTerms$"
          (submitSearch)="submitSearch($event)"
          [maxAutoSuggests]="configuration()?.maxAutoSuggests"
        />
        } @if (results.categories?.length) {
        <ish-suggest-categories
          [categories]="results.categories"
          [inputTerms$]="inputSearchTerms$"
          (routeChange)="resetInput()"
          [maxAutoSuggests]="3"
        />
        } @if (results.brands?.length) {
        <ish-suggest-brands
          [brands]="results.brands"
          [inputTerms$]="inputSearchTerms$"
          (routeChange)="resetInput()"
          [maxAutoSuggests]="3"
        />
        }
      </div>
      @if (results.products?.length) {
      <div
        [ngClass]="{
          'col-md-7': results.keywords.length || results.brands.length || results.categories.length,
          'products-only': !results.keywords.length && !results.brands.length && !results.categories.length
        }"
        class="col-12"
      >
        <ish-suggest-products
          [products]="results.products"
          [inputTerms$]="inputSearchTerms$"
          [deviceType]="deviceType()"
          (routeChange)="resetInput()"
          [maxAutoSuggests]="8"
        />
      </div>
      }
      <div class="col-12">
        <div class="show-all">
          <button
            type="button"
            class="btn btn-link"
            [title]="'search.searchbox.button.title' | translate"
            (click)="submitSearch(searchInput.value)"
          >
            {{ 'suggest.view_all.link' | translate }}
          </button>
        </div>
      </div>
    </div>
    } @else { @if ((hasMinimumCharCount$ | async) || (searchedTerms$ | async)) {
    <div class="search-suggest-container" aria-live="polite">
      @if (hasMinimumCharCount$ | async) {
      <div class="col-12">
        <div class="d-flex justify-content-start headline">{{ 'suggest.no_results.headline' | translate }}</div>
        <p>{{ 'suggest.no_results.text' | translate }}</p>
      </div>
      } @if (searchedTerms$ | async) {
      <div class="col-12">
        <ish-suggest-search-terms
          [maxRecentlySearchedWords]="5"
          [inputTerms$]="inputSearchTerms$"
          (submitSearch)="submitSearch($event)"
        />
      </div>
      }
    </div>
    } } } @else { @if ((searchedTerms$ | async) && configuration()?.autoSuggest) {
    <div class="search-suggest-container">
      <div class="col-12">
        <ish-suggest-search-terms
          [maxRecentlySearchedWords]="5"
          [inputTerms$]="inputSearchTerms$"
          (submitSearch)="submitSearch($event)"
        />
      </div>
    </div>
    } } @if (searchSuggestLoading$ | async) {
    <div class="loading"></div>
    }

    <div class="buttons">
      <!-- Clear input button -->
      @if (inputSearchTerms$ | async) {
      <button
        class="btn btn-reset"
        type="reset"
        name="reset"
        [title]="'search.searchbox.button.reset.title' | translate"
        (focus)="handleFocus(true)"
        (click)="handleResetButton($event); setFocusOnSearchInput()"
      >
        <fa-icon [icon]="['fas', 'times']" class="searchbox-icon" />
      </button>
      }

      <!-- Search button -->
      <button
        class="btn btn-secondary btn-search"
        type="submit"
        name="search"
        [title]="'search.searchbox.button.title' | translate"
        (focus)="handleFocus(true)"
        (click)="submitSearch(searchInput.value)"
      >
        <!-- search button with icon -->
        @if (!configuration()?.buttonText) {
        <fa-icon [icon]="['fas', usedIcon]" class="searchbox-icon" />
        } @else {
        {{ configuration()?.buttonText }}
        }

        <!-- search button with text -->
      </button>
    </div>
  </div>
  <div class="search-suggest-backdrop" (click)="clickedOnBackdrop()" [ngClass]="{ show: searchBoxFocus }"></div>
</div>
